var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRegalo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 712.6 799.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gift"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m646.3,799.43H67.5c-23.16,0-41.3-18.14-41.3-41.3v-345h25v345c0,9.29,7.01,16.3,16.3,16.3h578.8c9.29,0,16.3-7.01,16.3-16.3v-345h25v345c0,23.16-18.14,41.3-41.3,41.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape-2",
    "data-name": "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m671.3,424.52H41.3c-23.16,0-41.3-18.14-41.3-41.3v-128.8c0-23.16,18.14-41.3,41.3-41.3h630c23.16,0,41.3,18.14,41.3,41.3v128.8c0,23.16-18.14,41.3-41.3,41.3ZM41.3,238.12c-9.29,0-16.3,7.01-16.3,16.3v128.8c0,9.29,7.01,16.3,16.3,16.3h630c9.29,0,16.3-7.01,16.3-16.3v-128.8c0-9.29-7.01-16.3-16.3-16.3H41.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape-3",
    "data-name": "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m377.82,232.62c-11.24,0-20-3.06-26.37-9.17l-.19-.19c-16.66-16.66-11.05-51.08,17.12-105.26,20.93-40.24,48.41-79.25,62.88-93.72,15.66-15.66,36.61-24.29,58.99-24.29s43.48,8.56,59.7,24.1l.19.19c15.66,15.66,24.29,36.79,24.29,59.49s-8.62,43.83-24.29,59.49c-14.58,14.58-53.43,42.08-93.2,62.86-33.84,17.69-60.05,26.49-79.12,26.49Zm-8.97-27.12c4.58,4.08,26.24,4.74,76.51-21.52,37.15-19.41,74.13-45.42,87.1-58.39,22.63-22.63,22.66-60.85.09-83.53-23.63-22.55-61.11-22.6-83.62-.09-12.85,12.85-38.82,49.99-58.37,87.58-27.18,52.25-24.95,72.41-21.71,75.95Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape-4",
    "data-name": "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m334.26,233.76c-50.09,0-149.71-67.21-173-90.5l-.19-.19c-16.12-16.82-24.69-38.7-24.15-61.6.51-21.57,9.19-41.46,24.46-56,32.42-32.29,85.05-32.29,117.46.02,26.1,25.1,90.1,123.34,90.62,172.21.12,11.45-3.01,20.45-9.32,26.76-6.09,6.14-14.78,9.28-25.78,9.3h-.1Zm-155.23-108.08c10.31,10.27,38.89,31.3,71.73,50.22,36.28,20.89,66.7,32.86,83.49,32.86h.06c3.94,0,6.9-.72,8.11-1.94,1.35-1.35,2.08-4.57,2.04-8.85-.42-39.73-59.99-132.46-83.01-154.52l-.19-.19c-22.7-22.7-59.62-22.7-82.32,0l-.23.23c-10.47,9.94-16.44,23.64-16.79,38.57-.38,16.17,5.7,31.65,17.12,43.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape-5",
    "data-name": "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m373.8,785.62h-25V260.11c-19.83,10.44-36.48,24.25-49.65,41.19-12.61,16.23-17.14,29.43-17.19,29.57l-23.74-7.82c.84-2.57,21.5-63.42,98.46-94.03l17.12-6.81v563.42Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Shape-6",
    "data-name": "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m483.25,369.29c-44.26-6.64-82.34-30.19-110.13-68.1-20.78-28.34-28.51-54.7-28.83-55.81l24.02-6.94c.07.24,7.09,23.82,25.48,48.65,24.05,32.47,55.39,51.81,93.17,57.47l-3.71,24.72Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegalo);
export default __webpack_public_path__ + "static/media/regalo.08555b903f998b3d1248e71a19e1c403.svg";
export { ForwardRef as ReactComponent };